import * as Flex from '@twilio/flex-ui';
import * as $ from 'jquery';
import * as FlexStore from './FlexStore';

import {
  CHANNEL_TYPES,
  CONTEXTUAL_OPERATION_TYPE,
  LOG_LEVEL,
  addContextualContacts,
  enableClickToDial,
  getPresence,
  initializeComplete,
  logout,
  registerClickToDial,
  registerContextualControls,
  registerOnLogout,
  registerOnPresenceChanged,
  setAppHeight,
  setPresence,
  setSupportedChannels,
} from '@amc-technology/davinci-api';

import React from 'react';
import { Scenario } from './Scenario';
import { getContactsId } from './util';

export class AMCRoot extends React.Component {
  constructor(props) {
    const fname = 'constructor';

    super(props);
    this.toggleCallControls = this.toggleCallControls.bind(this);
    this.storeListener = this.storeListener.bind(this);

    this.state = {
      tasks: [],
      apiUrl: props.config.serverConfig.apiUrl,
      iconPack: props.config.serverConfig.iconPack,
      shouldDisableCallControls: false,
      loggerApiUrl: props.config.serverConfig.loggerApiUrl,
    };

    this.props = props;
    if (
      this.props.config.daVinciAppConfig &&
      this.props.config.daVinciAppConfig.CADDisplay &&
      this.props.config.daVinciAppConfig.CADDisplay.variables
    ) {
      this.cadDisplay = this.props.config.daVinciAppConfig.CADDisplay.variables;
    }

    if (this.props.config.daVinciAppConfig.variables && this.props.config.daVinciAppConfig.variables.UseAMCUI === false) {
      this.useAMCUI = false;

      // Override React functions here
      this.setState = (data) => {
        const fname = 'setState';
        const cname = 'AMCRoot';

        try {
          this.props.logger.log(LOG_LEVEL.Trace, fname, `${cname} - ${fname} - START`);

          for (const key in data) {
            this.props.logger.log(LOG_LEVEL.Loop, fname, `${cname} - ${fname} - Processing key ${key}`);

            if (data.hasOwnProperty(key)) {
              // eslint-disable-next-line react/no-direct-mutation-state
              this.state[key] = data[key];
            }
          }
        } catch (e) {
          this.props.logger.log(LOG_LEVEL.Error, fname, `${cname} - ${fname} - Error: ${JSON.stringify(e)}`);
        } finally {
          this.props.logger.log(LOG_LEVEL.Trace, fname, `${cname} - ${fname} - END`);
        }
      };
    } else {
      this.useAMCUI = true;
    }

    this._lastHeight = 0;
    this.finishedTasks = {};
    this.syncPresenceSIDtoFramework = undefined;
    this.syncPresenceSIDtoTwilio = undefined;
    this.serviceBaseUrl = `https://${this.props.manager.serviceConfiguration.runtime_domain}`;

    $.ajax({
      url: `https://taskrouter.twilio.com/v1/Workspaces/${props.manager.serviceConfiguration['taskrouter_workspace_sid']}/Workers`,
      headers: {
        Authorization:
          'Basic ' + btoa(props.config.daVinciAppConfig.variables.AccountSID + ':' + props.config.daVinciAppConfig.variables.AuthToken),
      },
    }).then((result) => this.setState({ workers: result.workers }));
    $.ajax({
      url: `https://taskrouter.twilio.com/v1/Workspaces/${props.manager.serviceConfiguration['taskrouter_workspace_sid']}/TaskQueues`,
      headers: {
        Authorization:
          'Basic ' + btoa(props.config.daVinciAppConfig.variables.AccountSID + ':' + props.config.daVinciAppConfig.variables.AuthToken),
      },
    }).then((result) => this.setState({ taskQueues: result.task_queues }));

    registerOnPresenceChanged((presence, reason, appName) => {
      const fname = 'registerOnPresenceChanged';
      try {
        if (appName !== this.props.config.daVinciAppConfig.name) {
          if (
            this.syncPresenceSIDtoFramework === this.props.config.daVinciAppConfig.variables.WorkMode[presence] &&
            this.syncPresenceSIDtoTwilio === this.props.config.daVinciAppConfig.variables.WorkMode[presence]
          ) {
            this.props.logger.log(
              LOG_LEVEL.Debug,
              fname,
              'Skip Set Presence, already in ' + presence + ' ' + this.props.config.daVinciAppConfig.variables.WorkMode[presence],
            );
          } else {
            try {
              const activity = this.props.config.daVinciAppConfig.variables.WorkMode[presence];
              this.props.logger.log(LOG_LEVEL.Debug, fname, `on presence changed; presence=${presence}; activity=${activity}`);
              if (this.props.config.daVinciAppConfig.variables.WorkMode[presence]) {
                Flex.Actions.invokeAction('SetActivity', {
                  activitySid: activity,
                }).catch((error) => this.props.logger.log(LOG_LEVEL.Error, fname, `Error12; ${error.message}`));
                this.syncPresenceSIDtoTwilio = this.props.config.daVinciAppConfig.variables.WorkMode[presence];
              }
            } catch (e) {
              this.props.logger.log(LOG_LEVEL.Error, fname, `Error on presence changed: ${e.message}`);
            }
          }
          return Promise.resolve();
        }
      } catch (error) {}
    });

    registerOnLogout(async () => {
      const fname = 'registerOnLogout';
      try {
        this.props.logger.log(LOG_LEVEL.Debug, fname, 'Logout');
        await this.props.logger.logger.pushLogsAsync();
        await Flex.Actions.invokeAction('Logout', {
          activitySid: this.props.config.daVinciAppConfig.variables.WorkMode['Logout'],
        });

        this.syncPresenceSIDtoTwilio = this.props.config.daVinciAppConfig.variables.WorkMode['Logout'];
      } catch (exception) {
        this.props.logger.log(LOG_LEVEL.Error, fname, `Error on logout: ${exception.message}`);

        // TODO: Throw error here to reject the promise if we need to
      }
    });

    try {
      if (this.props.config.daVinciAppConfig.variables.EnableLivePresence) {
        const state = this.props.manager.store.getState();
        const workerSid = state.flex.worker.worker.sid;
        setSupportedChannels([
          {
            channelType: CHANNEL_TYPES.Telephony,
            idName: 'worker',
            id: workerSid,
            validOperations: [
              CONTEXTUAL_OPERATION_TYPE.BlindTransfer,
              CONTEXTUAL_OPERATION_TYPE.Conference,
              CONTEXTUAL_OPERATION_TYPE.Consult,
              CONTEXTUAL_OPERATION_TYPE.Other,
              CONTEXTUAL_OPERATION_TYPE.WarmTransfer,
            ],
            validPresences: this.props.config.daVinciAppConfig.variables.LivePresenceValidPresences || [],
            customValues: {
              token: this.props.manager.user.token,
              // workerSID: this.props.manager.workerClient["sid"],
              workerSID: workerSid,
              workerURI: this.props.manager.workerClient.attributes['contact_uri'],
            },
          },
        ]);
      }
    } catch (error) {
      this.props.logger.log(LOG_LEVEL.Error, fname, `AMCRoot - setSupportedChannels problem: ${error.message}`);
    }

    initializeComplete(this.props.logger.logger)
      .then(() => {
        const fname = 'initializeCompleteHandler';
        addContextualContacts([]);
        this.resize();
        enableClickToDial(true);
        this.props.logger.log(LOG_LEVEL.Debug, fname, 'initializeComplete');
      })
      .catch((error) =>
        this.props.logger.log(LOG_LEVEL.Error, 'initializeCompleteHandler', `AMCRoot - initializeComplete - ${error.message} `),
      );

    registerContextualControls((contact) => {
      const fname = 'registerContextualControls';
      try {
        const toDial = getContactsId(contact);
        this.props.logger.log(LOG_LEVEL.Debug, fname, `Register Contextual Controls : Outbound : phone number =${toDial}`);
        this.clickToDial(toDial);
      } catch (error) {
        this.props.logger.log(LOG_LEVEL.Error, fname, `RegisterContextualControls callback : Error = ${error.message}`);
      }

      return Promise.resolve();
    });

    registerClickToDial((phoneNumber, records) => {
      const fname = 'registerClickToDial';
      try {
        this.props.logger.log(LOG_LEVEL.Debug, fname, `Register Click to Dial : phone number = ${phoneNumber}`);
        this.clickToDial(phoneNumber);
      } catch (error) {
        this.props.logger.log(LOG_LEVEL.Error, fname, `Error on registerClickToDial: Error = ${error.message}`);
      }
      return Promise.resolve();
    });

    // Set starting activity
    Flex.Actions.invokeAction('SetActivity', {
      activitySid: this.props.config.daVinciAppConfig.variables.WorkMode['Not Ready'],
    });

    if (!this.useAMCUI) {
      this.componentDidMount();
    }
  }

  async componentDidMount() {
    const fname = 'componentDidMount';
    try {
      FlexStore.init(this.props.manager.store);
      FlexStore.subscribe(this.storeListener);
      await this.storeListener();
      this.resize();
    } catch (error) {
      this.props.logger.log(LOG_LEVEL.Error, fname, `Error: `, error);
    }
  }
  componentDidUpdate() {
    const fname = 'componentDidUpdate';
    try {
      this.resize();
    } catch (error) {
      this.props.logger.log(LOG_LEVEL.Error, fname, 'Error: ', error);
    }
  }

  async storeListener() {
    const fname = 'storeListener';
    try {
      const state = this.props.manager.store.getState();
      await this.syncAgentState(state);
      const tasks = [];
      const finishedTasks = this.finishedTasks;
      state.flex.worker.tasks.forEach((task, key) => {
        const attributesString = task.attributes !== undefined ? JSON.stringify(task.attributes) : 'undefined';
        this.props.logger.log(LOG_LEVEL.Loop, fname, `Handling Task : SID = ${task.taskSid}, Task attributes = ${attributesString}`);
        const channel = task.source.taskChannelUniqueName;
        if (
          (channel === 'voice' || channel === 'chat' || channel === 'sms' || channel === 'callback') &&
          !finishedTasks[task.attributes.from]
        ) {
          this.props.logger.log(LOG_LEVEL.Loop, fname, `Handling Task : SID = ${task.taskSid}, Task attributes = ${attributesString}`);
          let taskAssociatedData = [];
          if (task.attributes && this.cadDisplay && this.cadDisplay.DisplayCAD) {
            for (const key in this.cadDisplay.DisplayKeyList) {
              if (task.attributes[key]) {
                taskAssociatedData.push({
                  displayKey: this.cadDisplay.DisplayKeyList[key],
                  displayValue: task.attributes[key],
                  displayValueType: null,
                  visible: true,
                  displayOperation: null,
                });
              }
            }
          }
          this.props.logger.log(
            LOG_LEVEL.Critical,
            fname,
            `Sending Task To Twilio : taskSid = ${task.taskSid}, taskKey = ${key},` +
              ` attributes = ${attributesString}, associatedData = ${taskAssociatedData},` +
              ` workerSID = ${state.flex.worker.worker.sid}, flexToken = ${this.props.manager.user.token},` +
              ` workerURI = ${state.flex.worker.worker.attributes['contact_uri']}`,
          );
          tasks.push({
            taskSid: task.taskSid,
            taskKey: key,
            attributes: task.attributes,
            associatedData: taskAssociatedData,
            workerSID: state.flex.worker.worker.sid,
            flexToken: this.props.manager.user.token,
            workerURI: state.flex.worker.worker.attributes['contact_uri'],
          });
        }
      });
      tasks.sort();

      if (!this.arraysAreEqual(this.state.tasks, tasks)) {
        this.setState({ tasks: tasks });

        if (!this.useAMCUI) {
          const { manager } = this.props;

          if (!manager || !this.state.iconPack) {
            return null;
          }

          for (const task of tasks) {
            new Scenario({
              manager: manager,
              key: task.taskKey,
              taskId: task.taskSid,
              taskKey: task.taskKey,
              iconPack: this.state.iconPack,
              removeSelf: this.createRemoveScenario(task),
              resize: this.resize,
              workers: this.state.workers,
              logger: this.props.logger,
              taskQueues: this.state.taskQueues,
              associatedData: task.associatedData,
              toggleCallControls: this.toggleCallControls,
              config: this.props.config,
              flexToken: task.flexToken,
              workerSID: task.workerSID,
              workerURI: task.workerURI,
              attributes: task.attributes,
            });
          }

          return null;
        }
      }
    } catch (error) {
      this.props.logger.log(LOG_LEVEL.Error, fname, `Store listener, Error = ${error.message}`);
    }
  }

  arraysAreEqual(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
  }

  createRemoveScenario(task) {
    const fname = 'createRemoveScenario';
    return (taskWasTransferredToAgent) => {
      try {
        if (taskWasTransferredToAgent) {
          // This is a hacky fix for transferring tasks to agents.
          // We receive a new task when transfer occurs
          // Here we are ignoring tasks from the same phone number to avoid new setInteractions
          this.finishedTasks[task.attributes.from] = true;
          setTimeout(() => delete this.finishedTasks[task.attributes.from], 4 * 1000);
        }

        const tasks = this.state.tasks.filter((aTask) => aTask.taskSid !== task.taskSid);

        if (!this.arraysAreEqual(this.state.tasks, tasks)) {
          this.setState({ tasks: tasks });
        } else {
          this.setState(null);
        }
      } catch (error) {
        this.props.logger.log(LOG_LEVEL.Error, fname, `createRemoveScenario, Error = ${error.message}`);
      }
    };
  }

  async syncAgentState(state) {
    const fname = 'syncAgentState';
    try {
      // Only Sync presence if Logout is not raised
      if (this.syncPresenceSIDtoFramework !== this.props.config.daVinciAppConfig.variables.WorkMode['Logout']) {
        // If Logout is not triggered but, Flex is still offline and this.syncPresenceSID is still not initialized then, Sync the state from DaVinci Agent to Flex
        if (
          state.flex.worker.activity.sid === this.props.config.daVinciAppConfig.variables.WorkMode['Logout'] &&
          this.syncPresenceSIDtoFramework === undefined
        ) {
          try {
            getPresence().then((data) => {
              if (this.syncPresenceSIDtoFramework !== this.props.config.daVinciAppConfig.variables.WorkMode[data.presence]) {
                try {
                  Flex.Actions.invokeAction('SetActivity', {
                    activitySid: this.props.config.daVinciAppConfig.variables.WorkMode[data.presence],
                  });
                  this.syncPresenceSIDtoFramework = this.props.config.daVinciAppConfig.variables.WorkMode[data.presence];
                } catch (error) {
                  this.props.logger.log(LOG_LEVEL.Error, fname, 'Sync Presence from DaVinci To Flex - SetActivity, Error' + error.message);
                }
                this.props.logger.log(
                  LOG_LEVEL.Information,
                  fname,
                  'Sync Presence from DaVinci To Flex, ' +
                    data.presence +
                    ' ' +
                    this.props.config.daVinciAppConfig.variables.WorkMode[data.presence],
                );
              } else {
                this.props.logger.log(
                  LOG_LEVEL.Debug,
                  fname,
                  'Skip Sync Presence - already in ' +
                    data.presence +
                    ' ' +
                    this.props.config.daVinciAppConfig.variables.WorkMode[data.presence],
                );
              }
              return Promise.resolve();
            });
          } catch (error) {
            this.props.logger.log(LOG_LEVEL.Error, fname, `Sync Presence from DaVinci To Flex, Error = ${error.message}`);
          }
        } else if (
          state.flex.worker.activity.sid === this.props.config.daVinciAppConfig.variables.WorkMode['Logout'] &&
          this.syncPresenceSIDtoFramework !== undefined
        ) {
          // Agent logged out of Flex from Twilio side; Logout DaVinci Agent
          try {
            this.props.logger.log(LOG_LEVEL.Information, fname, 'Received a logout event from Twilio ' + state.flex.worker.activity.sid);
            await this.props.logger.logger.pushLogsAsync();
            logout();
            this.syncPresenceSIDtoFramework = state.flex.worker.activity.sid;
          } catch (error) {
            this.props.logger.log(LOG_LEVEL.Error, fname, 'Sync Presence logout from Flex, Error' + error.message);
          }
        } else {
          // Sync the state from Flex to DaVinci Agent
          if (this.syncPresenceSIDtoFramework !== state.flex.worker.activity.sid) {
            try {
              for (var property in this.props.config.daVinciAppConfig.variables.WorkMode) {
                if (!this.props.config.daVinciAppConfig.variables.WorkMode.hasOwnProperty(property)) continue;

                if (this.props.config.daVinciAppConfig.variables.WorkMode[property] === state.flex.worker.activity.sid) {
                  this.syncPresenceSIDtoFramework = state.flex.worker.activity.sid;
                  setPresence(property);
                  this.props.logger.log(
                    LOG_LEVEL.Information,
                    fname,
                    'Sync Presence from Flex to DaVinci ' + property + ' ' + state.flex.worker.activity.sid,
                  );
                  break;
                }
              }
            } catch (error) {
              this.props.logger.log(LOG_LEVEL.Error, fname, `Sync Presence from Flex to DaVinci, Error = ${error.message}`);
            }
          }
        }
      }
    } catch (error) {
      this.props.logger.logError.logError(`AMCRoot - synAgentState : ${error.message}`);
    }
  }

  /**
   * getAgentCallerId
   *
   * @param {object} Manager              Flex Manager
   * @param {object} [configVariables] parameters configuration object
   */
  getAgentCallerId(Manager, configVariables) {
    const fname = 'getAgentCallerId';
    try {
      if (Manager.workerClient && Manager.workerClient.attributes && Manager.workerClient.attributes.callerId) {
        return Manager.workerClient.attributes.callerId;
      }

      return (configVariables && configVariables.OutboundCallerId) || 'NO_CALLER_ID';
    } catch (error) {
      this.props.logger.log(LOG_LEVEL.Error, fname, `AMCRoot - getAgentCallerId : ${error.message}`);
    }
  }

  resize() {
    const fname = 'resize';
    try {
      const height = document.body.scrollHeight;
      if (height !== this._lastHeight) {
        this.props.logger.log(LOG_LEVEL.Loop, fname, `Updating height to ${height} from ${this._lastHeight}`);
        this._lastHeight = height;

        if (this.useAMCUI) {
          let numberOfTasks = this.state.scenario?.interactions?.length > 0 ? this.state.scenario.interactions.length : 0;
          this.props.logger.log(LOG_LEVEL.Loop, fname, `Number of tasks ${numberOfTasks}`);

          if (height === 0 && numberOfTasks > 0) {
            this.props.logger.log(LOG_LEVEL.Loop, fname, `Cannot set height to ${height} if there are active tasks.`);
          } else {
            this.props.logger.log(LOG_LEVEL.Trace, fname, `setAppHeight(${height})`);
            setAppHeight(height);
          }
        }
      }
    } catch (e) {
      this.props.logger.log(LOG_LEVEL.Error, fname, `Error on presence changed: ${e.message}`);
    }
  }

  toggleCallControls() {
    const fname = 'toggelCallControls';
    try {
      this.setState((state) => ({
        shouldDisableCallControls: !state.shouldDisableCallControls,
      }));
    } catch (error) {
      this.props.logger.log(LOG_LEVEL.Error, fname, `AMCRoot - toggleCallControls: ${error.message}`);
    }
  }

  async clickToDial(destinationNumber) {
    const fname = 'clickToDial';
    // Outbound dial
    try {
      this.props.logger.log(LOG_LEVEL.Debug, fname, `Sending number to flex : phone number = ${destinationNumber}`);
      await Flex.Actions.invokeAction('StartOutboundCall', {
        destination: destinationNumber,
      });
    } catch (error) {
      this.props.logger.log(LOG_LEVEL.Error, fname, `Error on initiating call: ${error.message}`);
    }
  }

  render() {
    const fname = 'render';
    try {
      const { manager } = this.props;
      if (!manager || !this.state.iconPack) {
        return null;
      }

      return (
        <div id="amc-root-twilio" className={this.state.shouldDisableCallControls ? 'disableCallControls' : ''}>
          {this.state.tasks.map((task) => {
            return (
              <Scenario
                manager={manager}
                key={task.taskKey}
                taskId={task.taskSid}
                taskKey={task.taskKey}
                iconPack={this.state.iconPack}
                removeSelf={this.createRemoveScenario(task)}
                resize={this.resize}
                workers={this.state.workers}
                logger={this.props.logger}
                taskQueues={this.state.taskQueues}
                associatedData={task.associatedData}
                toggleCallControls={this.toggleCallControls}
                config={this.props.config}
                flexToken={task.flexToken}
                workerSID={task.workerSID}
                workerURI={task.workerURI}
                attributes={task.attributes}
              />
            );
          })}
        </div>
      );
    } catch (error) {
      this.props.logger.log(LOG_LEVEL.Error, fname, `AMCRoot - render: ${error.message}`);
    }
  }
}
